import moment from "moment";

export const getGuestsStatistics = (input: {
  startDate: string;
  days: {
    day: number;
    totalGuests: number;
    overnightGuests: number;
  }[];
  prevdayGuests: number;
} | null | undefined, inputLister: {
  startDate: string;
  days: {
    day: number;
    totalGuests: number;
    overnightRoomsEZ: number;
    overnightRoomsDZ: number;
  }[];
} | null | undefined): {
  maxGuests: number;
  maxRoomsEZ: number;
  maxRoomsDZ: number;
  startDate: Date;
  endDate: Date;
} => {
  let maxGuests = 0;
  let maxRoomsEZ = 0;
  let maxRoomsDZ = 0;
  let startDate = new Date();
  let endDate = new Date();

  if (input) {
    maxGuests = Math.max(input.prevdayGuests, ...input.days.map(d => d.totalGuests)) || 0;
    maxRoomsEZ = Math.max(...input.days.map(d => d.overnightGuests)) || 0;

    const validDays = input.days.filter(d => d.overnightGuests > 0 || d.totalGuests > 0).map(d => d.day);
    const allDays = [...(input.prevdayGuests > 0 ? [-1] : []), ...input.days.map(d => d.day)];
    const maxDay = validDays.length > 0 ? Math.max(...validDays) : 0;
    const minDay = allDays.length > 0 ? Math.min(...allDays) : 0;

    startDate = moment.utc(input.startDate, 'YYYY-MM-DD').add(minDay, 'days').toDate();
    endDate = moment.utc(input.startDate, 'YYYY-MM-DD').add(maxDay, 'days').toDate();
  } else if (inputLister) {
    maxGuests = Math.max(...inputLister.days.map(d => d.totalGuests)) || 0;
    maxRoomsEZ = Math.max(...inputLister.days.map(d => d.overnightRoomsEZ)) || 0;
    maxRoomsDZ = Math.max(...inputLister.days.map(d => d.overnightRoomsDZ)) || 0;

    const validDays = inputLister.days.filter(d => d.overnightRoomsEZ > 0 || d.overnightRoomsDZ > 0 || d.totalGuests > 0).map(d => d.day);
    const maxDay = validDays.length > 0 ? Math.max(...validDays) : 0;
    const minDay = validDays.length > 0 ? Math.min(...validDays) : 0;

    startDate = moment.utc(inputLister.startDate, 'YYYY-MM-DD').add(minDay, 'days').toDate();
    endDate = moment.utc(inputLister.startDate, 'YYYY-MM-DD').add(maxDay, 'days').toDate();
  }

  return { maxGuests, maxRoomsEZ, maxRoomsDZ, startDate, endDate };
};